/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SwatchSelector_user$ref = any;
export type PdpRespSwatchSelector_user$ref = any;
export type PdpRespSwatchSelector_user = {
    readonly " $fragmentRefs": SwatchSelector_user$ref;
    readonly " $refType": PdpRespSwatchSelector_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSwatchSelector_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SwatchSelector_user",
      "args": null
    }
  ]
};
(node as any).hash = '7595c5be6c23d1e3712d8d28ffd08cef';
export default node;
